import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface MovieGridProps {
  movies: Movie[];
  columns?: 3 | 4 | 5;
}

const COLUMN_CLASS: Record<number, string> = {
  3: "grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5",
};

export default function MovieGrid({ movies, columns = 5 }: MovieGridProps) {
  return (
    <div className={`grid gap-4 md:gap-5 ${COLUMN_CLASS[columns]}`}>
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} />
      ))}
    </div>
  );
}